import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TrustpulseLogo } from '../../../components/TrustpulseLogo';
import classes from '../WorkEnvironmentFormSubmission.module.css';

const APP_LANGUAGES = [
  { code: 'no', label: 'Norsk' },
  { code: 'en', label: 'English' },
];

type Props = {
  /** Share of all questions answered, from 0 to 100. Without it, there is nothing to answer. */
  progress?: number;
  onLanguageChange: (code: string) => void;
};

export const SurveyHeader = ({ progress, onLanguageChange }: Props): ReactElement => {
  const { t, i18n } = useTranslation();
  const current = i18n.language.startsWith('en') ? 'en' : 'no';
  return (
    <header className={classes.header}>
      <div className={classes.headerContent}>
        <TrustpulseLogo />
        <div role="group" aria-label={t('workEnvironmentFormSubmission.appLanguage')} className={classes.languages}>
          {APP_LANGUAGES.map((language) => (
            <button
              key={language.code}
              type="button"
              lang={language.code}
              aria-pressed={current === language.code}
              onClick={() => onLanguageChange(language.code)}
            >
              {language.label}
            </button>
          ))}
        </div>
      </div>
      <div aria-hidden="true" className={classes.progressTrack}>
        {progress !== undefined && <span style={{ width: `${progress}%` }} />}
      </div>
    </header>
  );
};
